<template>
  <div>
    <div class="page-header">
      <span class="h3">Archived Assistants</span>
      <router-link to="assistants"><span class="h6 text-muted float-right">All Assistants</span></router-link>
    </div>

    <ul class="mt-2 list-group">
      <draggable v-model="allContacts" @start="drag=true" @end="drag=false" handle=".sort-handle">
        <transition-group type="transition" :name="'flip-list'">
          <li v-for="contact in allContacts" :key="contact.id" class="list-group-item">
            <div class='float-right d-flex align-items-center'>
              <i class="material-icons pointer ml-1 sort-handle">reorder</i>
            </div>
            <ContactTitle :contact=contact />
          </li>
        </transition-group>
      </draggable>
    </ul>
  </div>
</template>

<script>
import ContactTitle from "components/ContactTitle";
import api from "api";
import draggable from 'vuedraggable'

export default {
  components: {
    ContactTitle,
    draggable
  },  
  computed: {
    allContacts: { 
      set: function(value){
        var ordered_ids = []
        value.forEach(function(item, index){
          ordered_ids.push(item.id)
        })

        var payload = {
          name: 'archived_contacts',
          ordered_ids: ordered_ids
        }
        store.commit('updateSortedGroup', payload)

        return value;
      },
      get: function(){
        return store.getters.sortedArchivedContacts
      }
    }
  },
  methods: {
    unarchiveContact(contact) {
      $('#archiveModal' + contact.id).modal('hide')
      api.unarchiveContact(contact.id).then(response => {
        store.commit('addIdToSortedGroup', { name: 'contacts', id: contact.id })
      });
    },
  }
};
</script>
